<section
  class="locations-card"
  [class.with-list]="showList()"
  [class.without-map]="mapped().length === 0"
  [attr.aria-labelledby]="showList() ? 'redemption-locations-title' : null"
  [attr.aria-label]="showList() ? null : 'Standort'">
  @if (mapped().length > 0) {
    <div #map class="map" role="region" aria-label="Karte der Einlösestandorte"></div>
  }

  @if (showList()) {
    <div class="sidebar">
      <header class="sidebar-header">
        <h3 id="redemption-locations-title">Einlösestandorte</h3>
        <p>Dein Gutschein kann {{ countLabel() }} eingelöst werden.</p>
      </header>

      <ul #list class="location-list">
        @for (loc of locations(); track loc.id) {
          <li
            class="location"
            [class.is-active]="activeId() === loc.id"
            [attr.data-location-id]="loc.id">
            <ng-template #summary>
              <span class="avatar" aria-hidden="true">
                @if (loc.logo_image_path) {
                  <img [src]="imageUrl(loc.logo_image_path)" alt="" loading="lazy" />
                } @else {
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M13.5 21v-7.5A.75.75 0 0114.25 12h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016 2.993 2.993 0 002.25-1.016 3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72l1.189-1.19A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72M6.75 18h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .414.336.75.75.75z" />
                  </svg>
                }
              </span>
              <span class="location-text">
                <span class="location-name">{{ loc.company_name }}</span>
                @if (address(loc); as address) {
                  <span class="location-address">{{ address }}</span>
                }
              </span>
            </ng-template>

            @if (loc.latitude != null && loc.longitude != null) {
              <button
                type="button"
                class="location-main"
                [attr.aria-pressed]="activeId() === loc.id"
                (click)="showOnMap(loc)">
                <ng-container [ngTemplateOutlet]="summary" />
                <span class="sr-only">auf der Karte zeigen</span>
              </button>
            } @else {
              <div class="location-main">
                <ng-container [ngTemplateOutlet]="summary" />
              </div>
            }

            @if (loc.website) {
              <a
                class="location-website"
                [href]="websiteUrl(loc.website)"
                target="_blank"
                rel="noopener noreferrer"
                >{{ websiteLabel(loc.website) }}</a
              >
            }
          </li>
        }
      </ul>
    </div>
  }
</section>
